import React from 'react';
const lavPFP = '/images/Lavender_Long_Stories10.png';

export default function Welcome() {
    return (
        <section id="welcome">
            <img alt='lav' className={'lav-pfp'} src={lavPFP}/>
            <div className="welcome-content">
                <h1>Welcome</h1>
                <p>Hi there! You have made it to the personal website of Lavender-Long-Stories</p>
                <p>
                    I write Hinata-centric Naruto rare pair romance fanfiction on AO3.
                </p>
                <p>
                    I have written over 2 Million Words since 2024. Can I keep up the pace? You can keep track with me <a href="#goals">here</a>.
                </p>
                <p>
                    Lovely profile image by <a href="https://x.com/kersu_art">@kersu_art</a>.
                </p>
            </div>

        </section>
    )
}